import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import AnimatedRoutes from './components/AnimatedRoutes';
import './styles/main.css';

function App() {
  return (
    <Router>
      {/* 🔸 Reset posizione scroll con logica intelligente */}
      <ScrollToTop />

      {/* 🔸 Header e Footer statici */}
      <Header />

      {/* 🔸 Rotte animate (framer-motion gestisce le transizioni) */}
      <AnimatedRoutes />

      <Footer />
    </Router>
  );
}

export default App;
